
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[handle]/[articleHandle]",
      function () {
        return require("private-next-pages/blogs/[handle]/[articleHandle].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[handle]/[articleHandle]"])
      });
    }
  